<template>
  <div id="model-selector">
    <a
      href="javascript: void(0)" @click.prevent="$emit('input', '1950_2000')"
      data-shortname="1950_2000" :class="{selected: value == '1950_2000'}"
      v-tooltip="'Climatología base (1950-2000). WorldClim.'"
    >
        <span>Climatología Base</span>
    </a>
    <a
      href="javascript: void(0)" @click.prevent="$emit('input', 'CN')" data-shortname="CN"
      :class="{selected: value == 'CN'}"
      v-tooltip="'Modelo del Centre National de Recherches Meteorologiques (Francia)'"
    >
        <span>CNRMC-M5</span>
    </a>
    <a
      href="javascript: void(0)" @click.prevent="$emit('input', 'GF')" data-shortname="GF"
      :class="{selected: value == 'GF'}"
      v-tooltip="'Modelo del Geophysical Fluid Dynamics Laboratory (EEUU)'"
    >
        <span>GFDL-CM3</span>
    </a>
    <a
      href="javascript: void(0)" @click.prevent="$emit('input', 'HD')" data-shortname="HD"
      :class="{selected: value == 'HD'}"
      v-tooltip="'Modelo del Met Office Hadley Center (Reino Unido)'"
    >
        <span>HADGEM2-ES</span>
    </a>
    <a
      href="javascript: void(0)" @click.prevent="$emit('input', 'MP')" data-shortname="MP"
      :class="{selected: value == 'MP'}"
      v-tooltip="'Modelo del Max-Planck-Gesellschaft Institute for Meteorology (Alemania)'"
    >
        <span>MPI-ESM-LR</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'ModelSelector',

  props: [
    'value',
  ],
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

#model-selector {
  background-color: $color-clear;
  border-radius: $border-radius;
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  overflow: hidden;

  a {
    display: flex;
    align-items: center;
    justify-content: center;

    &.selected {
      background-color: darken($color-clear, 10%);
    }
  }
}

@media all and (max-width: $breakpoint-xl) {
  a {
    span {
      display: none;
    }

    &:after {
      content: attr(data-shortname);
    }
  }
}
</style>
